/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {ConfirmModal} from '@app/components/modals/ConfirmModal';
import UserStore from '@app/stores/UserStore';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const TooManyAttachmentsModal = observer(() => {
	const {t} = useLingui();
	const currentUser = UserStore.currentUser;
	const maxAttachments = currentUser?.maxAttachmentsPerMessage ?? 10;

	return (
		<ConfirmModal
			title={t`Whoa, this is heavy`}
			description={
				maxAttachments === 1
					? t`You can only upload 1 file at a time. Try again with fewer files.`
					: t`You can only upload ${maxAttachments} files at a time. Try again with fewer files.`
			}
			primaryText={t`Understood`}
			onPrimary={() => {}}
		/>
	);
});
